import { Mode } from '../enums';
import css from './style.module.css';

export const modePresets: Record<Mode, string> = {
  [Mode.PRIMARY]: css.primary,
  [Mode.CRITICAL]: css.critical,
  [Mode.SECONDARY]: css.secondary,
  [Mode.GRAY]: css.gray,
  [Mode.WHITE]: css.white,
};
